import ShopAdoptables from './ShopAdoptables';

export default ShopAdoptables;
